import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { GearSVG } from '../svg/gear.svg';

const GearIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <GearSVG/>
    </div>
  );
};

export { GearIcon };
